/**
 * AMAÇ: index.html'de media="print" ile render-blocking olmadan indirilen Inter font
 * CSS'ini devreye alır. CSP'de script-src için 'unsafe-inline' olmadığından
 * (Trusted Types + katı CSP) index.html'de inline onload="..." kullanılamıyor —
 * aynı işi bu harici (same-origin, CSP'nin izin verdiği) script yapıyor.
 */
const fontCss = document.getElementById('font-css');
if (fontCss) fontCss.media = 'all';
